(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DeviceService', DeviceService);


    function DeviceService() {
        const userAgent = navigator.userAgent || window.opera;

        function isMobile() {
            return /android|iphone|ipad|ipod|windows phone/i.test(userAgent);
        }

        function isAndroid() {
            return /android/i.test(userAgent);
        }

        function isIOS() {
            return /iphone|ipad|ipod/i.test(userAgent);
        }

        function isDesktop() {
            return !isMobile();
        }

        return {
            isMobile: isMobile,
            isAndroid: isAndroid,
            isIOS: isIOS,
            isDesktop: isDesktop
        };
    }
})()